import { render, staticRenderFns } from "./AttendLink.vue?vue&type=template&id=19be1ac7"
import script from "./AttendLink.vue?vue&type=script&lang=js"
export * from "./AttendLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports